export default "__VITE_ASSET__CT7xsd8A__"